import React from 'react'
import useSWR from 'swr'
import { IncomeTable } from '../../../components'
import { buildCacheKey } from '../../../util'
import { useParamsIncomesQuerySync } from '../../../hooks'
import api from '../../../api'
import { EIncomeLevel } from '../../../typings'

interface Props {
	level: EIncomeLevel
}

const IncomesTablePage: React.FC<Props> = ({ level }) => {
	const query = useParamsIncomesQuerySync()
	const cacheKey = buildCacheKey('income', 'list', {
		query,
	})

	const { data } = useSWR<APIDataResponse<Entities.Income.Object>>(
		cacheKey,
		async () => {
			try {
				const params = { ...query, level }
				const response = await api.get('/incomes', {
					params,
				})

				return response.data.data
			} catch (error) {
				console.error(error)
			}
		}
	)

	return <IncomeTable data={data} />
}

export default IncomesTablePage
